import React from "react";
import { controllerPortDetails, controllerAuxPort, controllerPowerInput, controllerPumpPort } from "./ControllerBoardModel";

export function ControllerPortDetail({ detail, onClose }) {
  return <aside className="feeder-scene3d-nozzle-detail" role="status" aria-label="Controller-Anschlussdetails">
    <strong>{detail.ref} · {detail.label}</strong>
    <span>{detail.connector}</span><span>{detail.description}</span>
    <small>{detail.partId === "leaf" ? "Indirekter Blattwasserstatus, kein absoluter Turgordruck." : "Zuordnung nach Rev28; kein Verdrahtungsplan oder Pinout."}</small>
    <button type="button" onClick={onClose} aria-label="Anschlussdetails schließen">×</button>
  </aside>;
}

export default function ControllerPortGuide({ activeRef = "", side = "ports", disabled = false, onSelect, onSide }) {
  return <section className="feeder-controller-ports" aria-label="Anschlüsse der STM32-Platine">
    <header><div><h3>Welcher Anschluss kommt wohin?</h3><p>Netzteil → X2 / Controller → X1 / Pumpe. Sensoranschlüsse bleiben getrennt.</p></div>
      <div className="feeder-controller-sides" role="group" aria-label="Platinenseite ansehen">
        <button type="button" disabled={disabled} aria-pressed={side === "ports"} onClick={() => onSide("ports")}>Anschlussseite</button>
        <button type="button" disabled={disabled} aria-pressed={side === "display"} onClick={() => onSide("display")}>Bildschirm auf Rückseite</button>
      </div>
    </header>
    <ul>{[controllerPowerInput, controllerPumpPort, ...controllerPortDetails, controllerAuxPort].map(port => <li key={port.ref}>
      <button type="button" disabled={disabled} aria-pressed={activeRef === port.ref} onClick={() => onSelect(port.ref)} aria-label={`${port.ref} ${port.label} am Controller ansehen`}>
        <strong>{port.ref} · {port.label}</strong><span>{port.connector}</span>
      </button><p>{port.description}</p>
    </li>)}</ul>
    <p className="feeder-controller-port-note">RJ45 ist hier nur die Steckerform – nicht Ethernet oder PoE. Das Display liegt auf der gegenüberliegenden Platinenseite. Positionen folgen dem Board; Gehäuse und Kabel sind vereinfacht. EC braucht Kalibrierung. Leaf beschreibt den indirekten Blattwasserstatus, keinen absoluten Turgordruck. Keine Verbindung zu realer Hardware.</p>
  </section>;
}
